/**
 * AddCategorySetCtrl controller
 * Add/edit category sets
 */

// controller mixins
AddCategorySetCtrl.mixes = [{
  m2mCtrlMixin: [
    'cs', // entity with m2m field
    'networks', // entity field
    undefined, // vm field (same as entity above)
    function () {
      // dropdown doesn't store selected value. we need an additional validation on delete
      this.$scope.form.network.$setValidity('required', this.cs.networks.length !== 0) // eslint-disable-line no-invalid-this
    }
  ]
}]

/**
 * AddCategorySetCtrl controller
 *
 * @class AddCategorySetCtrl
 * @memberof mwApp/sets
 * @see mwApp/sets
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/sets.controller:AddCategorySetCtrl
 */
/* @ngInject */
export default function AddCategorySetCtrl ($scope, $uibModalInstance, Network, cs, categorySetNames) {
  var vm = this
  vm.$scope = $scope
  vm.cs = cs
  vm.isNew = cs._isNew()
  vm.isLoad = false

  vm.categorySetNames = vm.isNew
    ? categorySetNames
    : categorySetNames.filter(n => n !== cs.name)

  // get networks
  Network.loadAll('?withoutCategorySetType=' + cs.categorySetType)
    .except(cs.networks) // remove networks, already existed in set
    .to(vm.networks = [])
    .then(
      () => {
        // dropdown doesn't store selected value. we need an additional validation on delete
        if (cs.networks.length > 0) {
          $scope.form.network.$setValidity('required', true)
        }
        vm.isLoad = true
      }
    )

  /**
   * Submit form
   */
  vm.submit = function () {
    vm.setDisable()
    cs._save(
      cs => { cs.categories = null } // don't send categories
    ).then(
      () => $uibModalInstance.close(cs)
    ).finally(vm.unsetDisable)
  }

  /**
   * Cancel, close form
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
